import React from "react";
import { StyledButton } from "../../Common/Components";
import PermissionCheck from "../../Common/PermissionCheck";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import EditPool from "./EditPool";

const PermissionName = PermissionNames.POOL;

export const getColumns = ({ formatMessage, handleDeleteIntent, refetch }) => [
  {
    title: formatMessage({
      id: "name.local",
      defaultMessage: "Local Name",
    }),
    dataIndex: "nameLocal",
  },
  {
    title: formatMessage({
      id: "abbreviationLocal",
      defaultMessage: "Pool abbr",
    }),
    dataIndex: "abbreviationLocal",
  },
  {
    title: formatMessage({
      id: "pool.order",
      defaultMessage: "Pool Order",
    }),
    dataIndex: "poolOrder",
    sorter: (a, b) => a.poolOrder - b.poolOrder,
  },
  {
    title: `${formatMessage({
      id: "external",
      defaultMessage: "External",
    })} ID`,
    dataIndex: "externalId",
  },
  {
    align: "right",
    render: (value, row) => (
      <>
        <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.UPDATE]}>
          <EditPool refetch={refetch} poolCode={value?.poolCode} />
        </PermissionCheck>
        <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.DELETE]}>
          <StyledButton
            icon={<i className={"fas fa-trash"} />}
            type="text"
            size="small"
            onClick={() => handleDeleteIntent(row.poolCode)}
          />
        </PermissionCheck>
      </>
    ),
  },
];
